import { AnalyticsData } from 'types'
import { getIsoStringYearMonthDay, getLocationId, getShopId, useApiQuery } from 'utils'

export const useAnalytics = (start: Date, end: Date) => {
    const shopId = getShopId()
    const locationId = getLocationId()

    return useApiQuery<AnalyticsData>({
        query: `
            query getAnalytics(
                $shop: String!,
                $request: GetAnalyticsRequest!
            ) {
                getAnalytics(
                    shop: $shop,
                    request: $request
                ) {
                    data {
                        actual
                        name
                        value {
                            appointments
                            sales
                        }
                    }
                    topServices {
                        id
                        title
                        count
                        image {
                            id
                            path
                        }
                    }
                    currency
                    currencySymbol
                    totalSales
                }
            }
        `,
        variables: {
            shop: shopId,
            request: {
                start: getIsoStringYearMonthDay(start),
                end: getIsoStringYearMonthDay(end),
                ...(locationId && { locationId }),
            },
        },
        cacheKey: ['analytics', shopId, locationId, start, end],
        onSuccess: response => response.data.getAnalytics,
    })

}
